import * as Sentry from '@sentry/nextjs'
import { ScoUser } from '@src/graphql-types'

type SentryUserSource = Pick<ScoUser, 'userId' | 'isGuest' | 'isAdmin'> | null | undefined

/**
 * Sentry user + tags for the signed-in browser user. Id only — no email, name
 * or IP (owner decision, 2026-10-16). Mirrors startups3 `requestContext.js`.
 * The browser always authenticates with the session cookie.
 */
export function sentryUserContext(currentUser: SentryUserSource) {
  const signedIn = Boolean(currentUser?.userId && !currentUser.isGuest)
  return {
    user: signedIn ? { id: String(currentUser?.userId) } : null,
    tags: {
      authMethod: signedIn ? 'session' : 'guest',
      isAdmin: String(Boolean(signedIn && currentUser?.isAdmin)),
    },
  }
}

/** Browser only: the client scope belongs to this one visitor. */
export function applySentryUser(currentUser: SentryUserSource) {
  const { user, tags } = sentryUserContext(currentUser)
  Sentry.setUser(user)
  Sentry.setTags(tags)
}
